import * as yup from 'yup'

export const getPhoneNumberValidator = (requiredMessage: string, errorMessage: string, hasPrefix = false) => {
  const prefix = hasPrefix ? '(\\+)?' : '' // Add the '+' symbol if hasPrefix is true
  const regexPattern = new RegExp(`^${prefix}(\\(\\d{2,3}\\)[\\s-]*)?(\\d{2,4}[\\s-]*)*?\\d{3,4}[\\s-]*\\d{3,4}$`)

  return yup.string().required(requiredMessage).matches(regexPattern, errorMessage)
}
